import { Row, Col, Card, Descriptions, type DescriptionsProps } from 'antd';
import { useState } from 'react';
import { withAuthenticationRequired } from "@auth0/auth0-react";
import PaginatedTableDetalleProduccion from '../../../../components/reportes/produccion/detalle_produccion/PaginatedTableDetalleProduccion';
import { PageTitle } from '../../../../components/common';
import { theme } from '../../../../theme';

/**
 * Componente de Detalle de Producción
 * 
 * SEGURIDAD:
 * - Este componente está protegido por withAuthenticationRequired (línea 134)
 * - withAuthenticationRequired garantiza que solo usuarios autenticados puedan acceder
 * - No se requiere useAuth0 aquí porque este componente no accede directamente a datos del usuario
 * - El componente hijo (PaginatedTableDetalleProduccion) maneja useAuth0 cuando necesita datos del usuario
 * - La protección de la ruta está garantizada por withAuthenticationRequired, no por useAuth0
 */
const DetalleProduccion = () => {  

    // Para guardar la información agregada de la tabla.
    const [infoAgregada, setInfoAgregada] = useState<any>([]);

    // const [nro_cliente, setSelectedClient] = useState("all"); 


    // var startDate = new Date(2023, 0, 1);
    // var endDate = new Date(2023, 12, 31);

    // const [formDesdeFecha, setDesdeFecha] = useState(startDate)
    // const [formHastaFecha, setHastaFecha] = useState(endDate)
    /*
    <Row>
          <FiltrarDetalleProduccion2
            onDesdeFecha={setDesdeFecha} 
            onHastaFecha={setHastaFecha}
            selectedClient={setSelectedClient}
            DesdeFecha={formDesdeFecha}
            HastaFecha={formHastaFecha}/>
        </Row>
    */

    // Función para formatear números
    const formatNumber = (value: number | undefined): string => {
      if (value === undefined || value === null) return '0';
      return new Intl.NumberFormat('es-AR').format(value);
    };

    const items: DescriptionsProps['items'] = [
      {
        key: '0',
        label: 'Cliente',
        children: (infoAgregada.cliente === undefined) ? '-' : `${infoAgregada.cliente}`,
        span: 3
      },
      {
        key: '1',
        label: 'Productor',
        children: (infoAgregada.productor === undefined) ? '-' : `${infoAgregada.productor}`,
        span: 3
      },
      {
        key: '2',
        label: 'Bruto Fardos',
        children: formatNumber(infoAgregada.kg_total),
        span: 2,
      },
      {
        key: '3',
        label: 'Tara Fardos',
        children: formatNumber(infoAgregada.kg_tara),
        span: 2,
      },
      {
        key: '4',
        label: 'Fibra',
        children: formatNumber(
          infoAgregada.kg_total !== undefined && infoAgregada.kg_tara !== undefined
            ? infoAgregada.kg_total - infoAgregada.kg_tara
            : undefined
        ),
        span: 2,
      },
      {
        key: '5',
        label: 'Kg. Bruto Romaneo',
        children: formatNumber(infoAgregada.kg_romaneo_bruto),
        span: 2,
      },
      {
        key: '6',
        label: 'Rinde Fibra',
        children: infoAgregada.rinde_fibra === undefined ? '0%' : `${infoAgregada.rinde_fibra.toFixed(2)}%`,
        span: 2,
      },
      {
        key: '7',
        label: 'Cantidad Fardos',
        children: formatNumber(infoAgregada.cantidad_fardos),
        span: 2,
      },
      {
        key: '8',
        label: 'Resto (+)',
        children: formatNumber(infoAgregada.resto_positivo),
        span: 2,
      },
      {
        key: '9',
        label: 'Resto (-)',
        children: formatNumber(infoAgregada.resto_negativo),
        span: 2,
      }
    ];
    
    return (
      <div style={{ padding: '0' }}>
        <PageTitle>Detalle Producción</PageTitle>
        <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
          <Col xs={24} md={24} lg={24}>
            <Card 
              title="Resumen de Producción"
              style={{
                borderRadius: theme.styles.borderRadius,
                boxShadow: theme.styles.boxShadowLight,
              }}
              headStyle={{
                backgroundColor: theme.colors.primary,
                color: '#ffffff',
                fontWeight: 600,
                fontSize: '15px',
                padding: '12px 16px',
                borderTopLeftRadius: theme.styles.borderRadius,
                borderTopRightRadius: theme.styles.borderRadius,
              }}
              bodyStyle={{ padding: '16px' }}
            >
              <Descriptions 
                size="middle" 
                items={items}
                column={{ xs: 1, sm: 2, md: 3, lg: 4 }}
                labelStyle={{ 
                  fontWeight: 600,
                  fontSize: '13px',
                  color: theme.colors.textPrimary
                }}
                contentStyle={{
                  fontSize: '13px'
                }}
              />
            </Card>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={24} lg={24}>   
            <PaginatedTableDetalleProduccion
              csvName={"reporte_DetalleProduccion.xlsx"}
              getInfoAgregada={setInfoAgregada}
            />
          </Col>
        </Row>
      </div>
    );
};

/**
 * PROTECCIÓN DE SEGURIDAD:
 * withAuthenticationRequired es un HOC (Higher Order Component) de Auth0 que:
 * 1. Verifica si el usuario está autenticado antes de renderizar el componente
 * 2. Redirige automáticamente a la página de login si el usuario no está autenticado
 * 3. Garantiza que solo usuarios autenticados puedan acceder a esta ruta
 * 
 * Esta es la protección principal de seguridad. useAuth0 solo se necesita cuando
 * el componente requiere acceder a datos del usuario (como user.id_empresa, user.tipo_usuario, etc.)
 */
export default withAuthenticationRequired(DetalleProduccion);